import React, { useState } from 'react';
import { ListDashItens } from '../../../../../../components/NovoSistema/ListDashItens';
import ModalImageDash from '../../../../../../components/NovoSistema/ModalImageDash';
import SubTitle from '../../../../../../components/NovoSistema/SubTitle';

export default function DreEmpresa1() {
  const [openModal, setOpenModal] = useState(false);
  const prefix = '/docs/controladoria/dashboard/BAF/';
  const nameImage = 'dre-empresa1';
  return (
    <main>
      <SubTitle text="ANÁLISE – DRE Consolidado" />
      <ListDashItens>
        <li>Corte: AGO21.</li>
        <li>
          Previsão de fechamento do FY com Receita 6,26%, EBITDA Inalterado e Lucro líquido 9,59% maior do que
          planejado.
        </li>
        <li>Resultado decorrente de aumento de internações em decorrência do COVID19 e ganhos no Mercado de Opções.</li>
      </ListDashItens>
      <img
        onClick={() => setOpenModal(true)}
        src={`${prefix}${nameImage}.png`}
        alt={nameImage}
        style={{ width: '100%' }}
      />
      {openModal && <ModalImageDash close={setOpenModal} src={`${prefix}${nameImage}.png`} alt={nameImage} />}
    </main>
  );
}
